import { createAction } from "redux-actions";

// Create version
export const REQUESTED_CREATE_VERSION = "REQUESTED_CREATE_VERSION";
export const RECEIVED_CREATE_VERSION = "RECEIVED_CREATE_VERSION";

export const requestCreateVersion = createAction(REQUESTED_CREATE_VERSION);
export const receiveCreateVersion = createAction(
  RECEIVED_CREATE_VERSION,
  (version) => ({
    version,
  })
);

// Update version
export const REQUESTED_UPDATE_VERSIONS = "REQUESTED_UPDATE_VERSIONS";
export const RECEIVED_UPDATE_VERSIONS = "RECEIVED_UPDATE_VERSIONS";

export const requestUpdateVersions = createAction(REQUESTED_UPDATE_VERSIONS);
export const receiveUpdateVersions = createAction(
  RECEIVED_UPDATE_VERSIONS,
  (versions) => ({
    versions,
  })
);

export const REQUESTED_UPDATE_VERSION = "REQUESTED_UPDATE_VERSION";
export const RECEIVED_UPDATE_VERSION = "RECEIVED_UPDATE_VERSION";

export const requestUpdateVersion = createAction(REQUESTED_UPDATE_VERSION);
export const receiveUpdateVersion = createAction(
  RECEIVED_UPDATE_VERSION,
  (version) => ({
    version,
  })
);

// Delete vesion
export const REQUESTED_DELETE_VERSION = "REQUESTED_DELETE_VERSION";
export const RECEIVED_DELETE_VERSION = "RECEIVED_DELETE_VERSION";

export const requestDeleteVersion = createAction(REQUESTED_DELETE_VERSION);
export const receiveDeleteVersion = createAction(
  RECEIVED_DELETE_VERSION,
  (version) => ({
    version,
  })
);

// Reset version status
export const REQUESTED_RESET_VERSION_STATUS = "REQUESTED_RESET_VERSION_STATUS";
